import type { ClockStamp } from '@/hooks/useClockStamp';
import type { useClockOutGuard } from '@/hooks/useClockOutGuard';
import { ChecklistClockOutDialog } from './ChecklistClockOutDialog';
import { EndTripDialog } from './EndTripDialog';
import { TripStartDialog } from './TripStartDialog';
import { WorkLocationDialog } from './WorkLocationDialog';

interface ClockStampDialogsProps {
  clockStamp: ClockStamp;
  /** The checklist warning before clock-out (ADR-0017) — left out where only clock-in happens. */
  clockOutGuard?: ReturnType<typeof useClockOutGuard>;
  todayIso?: string;
  busy: boolean;
}

/**
 * Every dialog a clock-in or clock-out may ask, in one place for the header widget, the
 * dashboard and the time clock page: checklist warning, "Homeoffice oder Büro?", the trip at
 * clock-in and the running trip at clock-out (FAFD-68). Render it outside dropdowns — closing
 * one must not unmount a dialog. Modal portals to body.
 */
export function ClockStampDialogs({ clockStamp, clockOutGuard, todayIso, busy }: ClockStampDialogsProps) {
  return (
    <>
      {clockOutGuard && (
        <ChecklistClockOutDialog
          isOpen={clockOutGuard.dialogOpen}
          todayIso={todayIso ?? ''}
          dayGroups={clockOutGuard.dayGroups}
          busy={busy}
          onCancel={clockOutGuard.dismissDialog}
          onClockOutAnyway={clockOutGuard.clockOutAnyway}
        />
      )}
      <WorkLocationDialog {...clockStamp.locationDialog} busy={busy} />
      <TripStartDialog {...clockStamp.tripStartDialog} busy={busy} />
      <EndTripDialog {...clockStamp.endTripDialog} busy={busy} />
    </>
  );
}
